module.exports = __webpack_public_path__ + "static/media/1.92afd2fb.png";